export default "__VITE_ASSET__CwkF3s4D__"